// ======================================================================
// File Name       : LeftNavigatorConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import * as Path from './PathConstants';
import * as ICON from './IconConstants';
import { IS_SHOW_MENU_DEVELOP_FEATURE_51, IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 } from './index';

const LEFT_NAVIGATOR_CONFIG = [
  {
    title: 'トップ',
    path: Path.TOP_LIST,
    id: FUNCTION.TOP,
    icon: ICON.TOP,
    line: true
  },
  {
    title: '',
    id: FUNCTION.USER_GROUP,
    line: true,
    child: [
      {
        title: '受講ユーザー',
        path: Path.USER_LIST,
        id: FUNCTION.USER_LIST,
        icon: ICON.USER,
      },
      {
        title: 'ユーザーグループ',
        path: Path.GROUP_LIST,
        id: FUNCTION.GROUP_LIST,
        icon: ICON.GROUP,
      },
    ]
  },
  {
    title: '',
    id: FUNCTION.CONTENT,
    line: true,
    child: [
      {
        title: 'コース',
        path: Path.COURSE_LIST,
        id: FUNCTION.COURSE_LIST,
        icon: ICON.FLAG,
      },
      // Step 9.0.1 START
      {
        title: 'ビデオ',
        path: Path.CONTENT_VIDEO_LIST,
        id: FUNCTION.CONTENT_VIDEO_LIST,
        icon: ICON.TAB_VIDEO,
      },
      {
        title: 'ドキュメント',
        path: Path.CONTENT_DOCUMENT_LIST,
        id: FUNCTION.CONTENT_DOCUMENT_LIST,
        icon: ICON.TAB_DOCUMENT,
      },
      {
        title: 'リンク',
        path: Path.CONTENT_LINK_LIST,
        id: FUNCTION.CONTENT_LINK_LIST,
        icon: ICON.TAB_LINK,
      },
      // Step 9.0.1 END
      {
        title: 'ドリル',
        path: Path.CONTENT_DRILL_LIST,
        id: FUNCTION.CONTENT_DRILL_LIST,
        icon: ICON.DRILL,
      },
      {
        title: 'コンテンツグループ',
        path: Path.CONTENT_GROUP,
        id: FUNCTION.CONTENT_GROUP,
        icon: ICON.CONTENT_GROUP,
      },
      {
        title: '学習履歴',
        path: Path.USER_HISTORY_COURSE_LIST,
        id: FUNCTION.USER_HISTORY_COURSE_LIST,
        icon: ICON.LEARNING,
      },
      {
        title: 'コンテンツ配信管理',
        path: Path.CONTENT_DISTRIBUTION_LIST,
        id: FUNCTION.CONTENT_DISTRIBUTION_LIST,
        icon: ICON.SYNC,
      },
    ]
  },
  //  To do  
  // {
  //   title: 'コンテンツ',
  //   id: 'G_CONTENT',
  //   icon: ICON.FLAG,
  //   path: Path.COURSE_LIST,
  //   child: [
  //     {
  //       title: 'コンテンツ配布先管理',
  //       path: Path.CONTENT_DISTRIBUTION_LIST,
  //       id: FUNCTION.CONTENT_DISTRIBUTION_LIST,
  //       icon: ICON.SUB_MENU,
  //     },
  //     {
  //       title: '外部コンテンツ管理',
  //       path: Path.EXTERNAL_CONTENT_LIST,
  //       id: FUNCTION.EXTERNAL_CONTENT_LIST,
  //       icon: ICON.SUB_MENU,
  //     },
  //   ],
  // },
  //  To do
  {
    title: 'コミュニケーション',
    id: FUNCTION.G_COMMUNICATION,
    icon: 'chat',
    line: true,
    child: [
      {
        title: '添削管理',
        path: Path.SCORING_REPORT_TOP,
        id: FUNCTION.SCORING_REPORT_LIST,
        icon: ICON.SCORING,
      },
      {
        title: 'メッセージ管理',
        path: Path.SENT_MESSAGE_LIST,
        id: FUNCTION.SENT_MESSAGE_LIST,
        icon: ICON.MESSAGE,
      },
      {
        title: 'お知らせ',
        path: Path.SERVICE_NOTIFICATION_LIST,
        id: FUNCTION.SERVICE_NOTIFICATION_LIST,
        icon: ICON.NOTICE,
      },
      {
        title: 'メール連絡',
        path: Path.EMAIL_LIST,
        id: FUNCTION.EMAIL_LIST,
        icon: ICON.EMAIL,
      },
    ],
  },
  {
    title: 'システム',
    id: 'G_SYSTEM',
    id: FUNCTION.G_SYSTEM,
    line: false,
    child: [
    ],
  },
];

export default LEFT_NAVIGATOR_CONFIG;
